import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone',
})
export class TelefonePipe implements PipeTransform {

  readonly MASCARA_FIXO = '9999-9999';
  readonly MASCARA_CELULAR = '99999-9999';
  readonly MASCARA_DDD = '(99) ';

  transform(value: any) {
    if (value) {
      value = value.replace(/\D/g, '');
      if (value.length < 8 || value.length > 11) {
        return value;
      }

      let mascara;
      switch (value.length) {
        case 8:
          mascara = this.MASCARA_FIXO;
          break;

        case 9:
          mascara = this.MASCARA_CELULAR;
          break;

        case 10:
          mascara = this.MASCARA_DDD + this.MASCARA_FIXO;
          break;

        case 11:
          mascara = this.MASCARA_DDD + this.MASCARA_CELULAR;
          break;
      }
      return this.applyMask(mascara, value);
    }
    return value;
  }

  applyMask(mask, value) {
    let i = 0;
    let maskedValue = '';

    for (let index = 0; index < mask.length; index++) {
      if (i >= value.length) {
        break;
      }

      if (!isNaN(parseFloat(mask[index]))) {
        maskedValue = maskedValue + value[i++];
      } else {
        maskedValue = maskedValue + mask[index];
      }
    }
    return maskedValue;
  }

}
